export const isValidPersonFormat = (inputString) => {
  // Test the inputString if in the format - Firstname Lastname (email)
  // Define the regex pattern
  const pattern = /^[A-Z][a-z]*(?: [A-Z][a-z]*)* [A-Z][a-z]*(?: [A-Z][a-z]*)* \([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\)$/;

  // Test the string against the pattern
  return pattern.test(inputString);
};




// WEBPACK FOOTER //
// ./src/helpers/inspection_owner_helpers.js